/**
 * AureNovel 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/**
 * AureNovel 品牌特定主题配置
 */
export const theme = {
  // 按钮背景色
  btnBg: '#FFF8E8',
  // 按钮文本颜色 (使用主色)
  btnText: brandTheme.primaryColor,
  // 金币颜色 (使用主色)
  coinsColor: brandTheme.primaryColor,
  // 金币数量渐变色
  coinsGradient: 'linear-gradient(90deg, #FFD666 0%, #FFB300 100%)',
  // 通用渐变色（任务按钮、弹窗按钮）
  actionGradient: brandTheme.primaryGradient,
  // Check-in 按钮渐变色
  checkinBtnGradient: 'linear-gradient(90deg, #FFD666 0%, #FFB300 100%), #FFB300',
} as const

/**
 * AureNovel 品牌特定资源配置
 */
export const resources = {
  // 首页背景图
  homeBg: '/images/aurenovel/welfare-bg.webp',
  // 金币图标
  welfareGold: '/images/aurenovel/welfare-gold.png',
  // 宝箱图标
  welfareBox: '/images/aurenovel/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
